import router from '@/router'
import {
    HomeStore
} from "@/slack/index";
router.beforeEach(async (to, from, next) => {
    let hasToken = HomeStore().token
    if (hasToken) {
        next()
    } else {
        let token = getCookie('token')
        if (token) {
            HomeStore().setToken(token)
            next()
        } else {
            next()
        }
    }
})
//读取指定cookie
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}